
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/residences",
      function () {
        return require("private-next-pages/residences/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/residences"])
      });
    }
  